/**
 * Calculate proper value range for period based on ledger lookup and current options
 *
 * @ledgerLookupCalendarYear object containing all ledgers in period (originally current ledger - 10 years till current ledger + 10 years)
 *                           calculated for calendar years
 * @ledgerLookupBookingYear  object containing all ledgers in period (originally current ledger - 10 years till current ledger + 10 years)
 *                           calculated for booking years
 * @startOffset start of the period offset
 * @endOffset end of the period offset
 * @valueOffset value
 * @yearType type of the year value is calculated on (calendar_year or booking_year)
 * @calcFrequency frequency in which value is calculated (monthly, quarterly, yearly)
 * @priorPeriodYears if prior years ends on a current month or at the end of the year(current_month, end_of_bookyear)
 * @connector range connector (originally "to")
 * @defaultRange if range doesn't conatin any ledgers this value will be returned
 */

const ledgerRange = (
  ledgerLookupCalendarYear,
  ledgerLookupBookingYear,
  startOffset,
  endOffset,
  valueOffset,
  yearType,
  calcFrequency,
  priorPeriodYearsEnd,
  connector,
  defaultRange
) => {
  if (startOffset === null && endOffset === null) {
    return defaultRange
  }

  let start = startOffset
  let end = endOffset

  if (end === null) end = start
  start += valueOffset
  end += valueOffset

  let frequency = calcFrequency
  if (frequency === 'yearly' && priorPeriodYearsEnd === 'end_of_bookyear') {
    frequency = 'yearly_eoy'
  }

  const graphPeriodsRanges =
    yearType === 'booking_year'
      ? ledgerLookupBookingYear
      : ledgerLookupCalendarYear
  let resultRange = []

  for (let i = start; i <= end; i++) {
    resultRange = resultRange.concat(graphPeriodsRanges[i + 10][frequency])
  }

  if (resultRange.length >= 2) {
    return `${resultRange[0]} ${connector} ${
      resultRange[resultRange.length - 1]
    }`
  } else if (resultRange.length === 1) {
    return resultRange[0]
  } else {
    return defaultRange
  }
}

export default ledgerRange
